@import 'styles/mixins';
@import 'styles/variables';

.errorState {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  @include sm-regular;
}
